import { useCallback, useEffect, useState } from 'react'
import { useCurrentStore } from '@/context/CurrentStoreContext'
import { fetchContactUnreadCount } from '@/services/contactMessagesService'

/** Polls unread contact message count for the current store (sidebar badge). */
export function useContactUnreadTotal(enabled: boolean) {
  const { currentStore } = useCurrentStore()
  const storeId = currentStore?.storeId
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const refresh = useCallback(async () => {
    if (!enabled || storeId == null) {
      setTotal(0)
      return
    }
    setLoading(true)
    try {
      const { unreadCount } = await fetchContactUnreadCount(storeId)
      setTotal(unreadCount ?? 0)
    } catch {
      setTotal(0)
    } finally {
      setLoading(false)
    }
  }, [enabled, storeId])

  useEffect(() => {
    void refresh()
  }, [refresh])

  useEffect(() => {
    if (!enabled) return
    const onInboxEvent = () => void refresh()
    window.addEventListener('shopora-contact-inbox', onInboxEvent)
    const t = window.setInterval(() => void refresh(), 60_000)
    const onFocus = () => void refresh()
    window.addEventListener('focus', onFocus)
    return () => {
      window.removeEventListener('shopora-contact-inbox', onInboxEvent)
      window.clearInterval(t)
      window.removeEventListener('focus', onFocus)
    }
  }, [enabled, refresh])

  return { total, loading, refresh }
}
